import change_profile from './change_profile'
import change_password from './change_password';

export default {
  title: 'Налаштування',
  language: {
    title: 'Мова',
  },
  change_profile,
  change_password,
}
